import { EScheduledBy, EScheduleStatusValue } from './calendar';
import { EContactTypeV2, EServiceType } from './common';

export type TConversationStatus = 'ACTIVE' | 'ARCHIVED' | 'DELETED';

export enum EMessageType {
    TEXT = 'TEXT',
    EMAIL = 'EMAIL',
    APPOINTMENT = 'APPOINTMENT',
    AVA_REPLY = 'AVA_REPLY',
    QUESTION = 'QUESTION',
    TIME_LABEL = 'TIME_LABEL',
    UNREAD_MARK = 'UNREAD_MARK',
}

export enum EMessageSenderType {
    PATIENT = 'PATIENT',
    PROVIDER = 'PROVIDER',
    SYSTEM = 'SYSTEM',
}

export enum EWSAction {
    ERROR = 'ERROR',
    NEWMSG = 'NEWMSG',
}

export type TConversation = {
    conversationId: string;
    clientId: number;
    providerId: number;
    lastMessageId: string;
    lastMessageContent: string;
    lastMessageAt: string;
    lastMessageType: EMessageType;
    lastMessageSenderType: EMessageSenderType;
    unreadCount: number;
    status: TConversationStatus;
    pinned: boolean;
    pinTime: string | null;

    lastReadAt: string | null;
    createdAt: string;
    patientFirstName: string;
    patientLastName: string;
    providerFirstName: string;
    providerLastName: string;
    providerAvatarUrl: string | null;
};

export type TServerMessage = {
    messageId: string;//"10fb8578014c47e8aa6d6aff149f7ebd",
    conversationId: string;//"1417_106428",
    senderId: number;//106428,
    senderType: EMessageSenderType,
    receiverId: number;//106428,
    receiverType: EMessageSenderType,
    messageType: EMessageType,
    replyToMessageId?: string;//,
    visibleTo: EMessageSenderType[],
    createdAt: string;// "2025-05-27T07:53:58.952Z",
    updatedAt: string;//"2025-05-27T07:53:58.952Z",
    sortKey: string;//"2025-05-27T07:53:58.952Z#uqVYXS"

    content: string;// "{\"body\":\"Thank you for reaching out. I am Evan, your healthcare provider. How can I assist you today?\"}",
    aiReplyContent?: string,

};

export type TMessageText = {
    body: string,
};

export type TQuestion = {
    subject: string,
    body: string,
};

export enum EAppointmentType {
    RESCHEDULED = 'RESCHEDULED',
    PATIENT_CANCELED = 'PATIENT_CANCELED',
    PATIENT_LATE_CANCELED = 'PATIENT_LATE_CANCELED',
    PROVIDER_CANCELED = 'PROVIDER_CANCELED',
    NEW_APPOINTMENT_CREATED = 'NEW_APPOINTMENT_CREATED',
}

export type TAppointment = {
    type: EAppointmentType;
    id: number;
    appointmentName: string; //"Infections: Prescription service",
    providerId: number;
    clientId: number;
    startAt: string; //"2025-05-30T03:25",
    duration: number;
    contactType: EContactTypeV2;
    appointmentStatus: EScheduleStatusValue;//"scheduled",
    notes: string;
    reason: string;
    scheduledBy: EScheduledBy;
    serviceType: EServiceType;
    serviceSpecialty: string; //"Infections",
    serviceState: string; // "CA",
    createdAt: string;

    oldStartAt: string; // 旧的开始时间，可能是预约被重新安排后，原来的时间
    oldDuration?: number; // 旧的持续时间，可能是预约被重新安排后，原来的持续时间
    chargeFee?: number; // 费用，可能是预约被重新安排后，原来的费用
    // newStartAt: string;
    // fee: number | null; // 为空代表没有费用30
};

export type TEmail = {
    subject: string;
    sender: string;
    recevier: string;
    body: string;
    providerEmailId: number;
};

export type TAvaReply = {
    body: string;
    llmMessageId: string;
    feedBack?: 'like' | 'dislike' | null; // 空代表没有回复过
};

export type TMessage = {
    messageId: string;//"10fb8578014c47e8aa6d6aff149f7ebd",
    conversationId: string;//"1417_106428",
    senderId: number;//106428,
    senderType: EMessageSenderType,
    receiverId: number;//106428,
    receiverType: EMessageSenderType,
    replyToMessageId?: string;//,
    visibleTo: EMessageSenderType[],
    createdAt: string;// "2025-05-27T07:53:58.952Z",
    updatedAt: string;//"2025-05-27T07:53:58.952Z",
    sortKey: string;//"2025-05-27T07:53:58.952Z#uqVYXS"

    showSendTime?: boolean, // 是否显示发送时间
    messageType: EMessageType,
    text?: TMessageText,
    appointment?: TAppointment,
    question?: TQuestion,

    email?: TEmail,
    avaReply?: TAvaReply,
    timeLabel?: string,
};

export type TWSMessage = {
    action: EWSAction,
    uuid: string;// "87aebd9e27134e02b1d35d6e9a73ee37",
    payload?: TServerMessage,
};

export type TGetProviderAppointmentListInput = {
    current: number,
    size: number,
    type: 'Past' | 'Upcoming',
    clientId?: number,
};
